export const SESSION_SOURCE_NAME_PARAMETER_KEY = '_source_name';
export const SESSION_SOURCE_MEDIUM_PARAMETER_KEY = '_source_medium';
export const SESSION_SOURCE_TRIGGER_URL_PARAMETER_KEY = '_source_trigger';

export const SESSION_SOURCE_INSIGHT_ID_PARAMETER_KEY = 'insight';
